module.exports = __webpack_public_path__ + "img/katarina_amenities_7.945f9f1b.jpg";